export default __webpack_public_path__ + "static/media/Cage of the Cackling Marionette.4d6d272e.jpg";